import { useAuth } from '../context/AuthContext';
import { useLocation } from '../context/LocationContext';

const useAccessControl = () => {
  const { location } = useLocation();
  const locationId = location?.id;
  const { userHasPermission } = useAuth();

  return {
    userCanCorrectBill: userHasPermission('BOOKING_CORRECTION', locationId),
    userCanDiscard: userHasPermission('BOOKING_REMOVE_ITEMS', locationId),
    userCanDiscount: userHasPermission('DISCOUNTS_APPLY', locationId),
    userCanRefund: userHasPermission('BOOKING_REFUND_ITEMS', locationId),
  };
};

export default useAccessControl;
